import { render, staticRenderFns } from "./AtomSwitch.vue?vue&type=template&id=17a6fdca&scoped=true&"
import script from "./AtomSwitch.vue?vue&type=script&lang=js&"
export * from "./AtomSwitch.vue?vue&type=script&lang=js&"
import style0 from "./AtomSwitch.vue?vue&type=style&index=0&id=17a6fdca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a6fdca",
  null
  
)

export default component.exports